import React from "react";

const STATUS_MAP = {
  ORDER_RECEIVED: { label: "Order Received", cls: "bg-zinc-100 text-zinc-800 border-zinc-200" },
  RAW_MATERIALS: { label: "Raw Materials", cls: "bg-blue-50 text-blue-800 border-blue-200" },
  IN_PRODUCTION: { label: "In Production", cls: "bg-[#FF5A1F]/10 text-[#E04814] border-[#FF5A1F]/30" },
  QUALITY_TESTING: { label: "Quality Testing", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  READY_FOR_SHIPMENT: { label: "Ready for Shipment", cls: "bg-indigo-50 text-indigo-800 border-indigo-200" },
  SHIPPED: { label: "Shipped", cls: "bg-purple-50 text-purple-800 border-purple-200" },
  DELIVERED: { label: "Delivered", cls: "bg-green-50 text-green-800 border-green-200" },
};

export default function StatusChip({ status, testId }) {
  const s = STATUS_MAP[status] || { label: status, cls: "bg-zinc-100 text-zinc-800 border-zinc-200" };
  return (
    <span
      data-testid={testId || "status-chip"}
      className={`inline-flex items-center px-2.5 py-1 border text-[0.65rem] font-semibold uppercase tracking-[0.15em] ${s.cls}`}
    >
      {s.label}
    </span>
  );
}
